import { PlanDetails } from '@/contexts/plans'
import { ReceivingOptions } from '@/types/fees'
import { FlagsGroup, getCardBrandFromFlagsGroup } from '@/contexts/flagsGroup'
import { getPlanFeeByReceivingOptionAndFlag } from './getPlanFeeByReceivingOptionAndFlag'

export function sortPlansByLastFee(
  receivingOption: ReceivingOptions,
  flagsGroup: FlagsGroup
) {
  return function innerSortPlansByLastFee(
    planA: PlanDetails,
    planB: PlanDetails
  ) {
    const cardBrand = getCardBrandFromFlagsGroup(flagsGroup)

    const [lastFeeA] = getPlanFeeByReceivingOptionAndFlag(
      planA,
      receivingOption,
      cardBrand
    ).slice(-1)

    const [lastFeeB] = getPlanFeeByReceivingOptionAndFlag(
      planB,
      receivingOption,
      cardBrand
    ).slice(-1)

    return lastFeeA - lastFeeB
  }
}
